<template>
  <teleport to="body">
    <div v-if="visible" class="cv-fond" @click.self="$emit('fermer')">
      <div class="cv-carte card shadow">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0"><i class="bi bi-heart-pulse me-2 text-danger"></i>Constantes — {{ titre }}</h5>
          <button class="btn-close" @click="$emit('fermer')"></button>
        </div>
        <div class="card-body">
          <div class="row g-2">
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">TA systolique</label>
              <div class="input-group input-group-sm"><input v-model="f.tensionSystolique" type="number" class="form-control" placeholder="120"><span class="input-group-text">mmHg</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">TA diastolique</label>
              <div class="input-group input-group-sm"><input v-model="f.tensionDiastolique" type="number" class="form-control" placeholder="80"><span class="input-group-text">mmHg</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Pouls</label>
              <div class="input-group input-group-sm"><input v-model="f.pouls" type="number" class="form-control"><span class="input-group-text">bpm</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Température</label>
              <div class="input-group input-group-sm"><input v-model="f.temperature" inputmode="decimal" class="form-control" placeholder="37,0"><span class="input-group-text">°C</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Saturation O₂</label>
              <div class="input-group input-group-sm"><input v-model="f.saturation" type="number" class="form-control"><span class="input-group-text">%</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Fréq. respiratoire</label>
              <div class="input-group input-group-sm"><input v-model="f.frequenceRespiratoire" type="number" class="form-control"><span class="input-group-text">/min</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Poids</label>
              <div class="input-group input-group-sm"><input v-model="f.poids" inputmode="decimal" class="form-control"><span class="input-group-text">kg</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Taille</label>
              <div class="input-group input-group-sm"><input v-model="f.taille" type="number" class="form-control"><span class="input-group-text">cm</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Glycémie</label>
              <div class="input-group input-group-sm"><input v-model="f.glycemie" inputmode="decimal" class="form-control"><span class="input-group-text">g/L</span></div>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label small mb-1">Douleur (0 à 10)</label>
              <input v-model="f.douleur" type="number" min="0" max="10" class="form-control form-control-sm">
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label small mb-1">Observation</label>
              <input v-model="f.note" class="form-control form-control-sm">
            </div>
          </div>
          <div v-if="imc" class="small text-muted mt-2">IMC : <strong>{{ imc }}</strong></div>
          <div v-if="erreur" class="alert alert-danger mt-3 mb-0 py-2">{{ erreur }}</div>
        </div>
        <div class="card-footer text-end">
          <button class="btn btn-secondary me-2" @click="$emit('fermer')">Annuler</button>
          <button class="btn btn-primary" :disabled="enCours" @click="enregistrer">Enregistrer</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import api, { messageErreur, notifier } from '@/api'

const VIDE = { tensionSystolique: '', tensionDiastolique: '', pouls: '', temperature: '', saturation: '', frequenceRespiratoire: '', poids: '', taille: '', glycemie: '', douleur: '', note: '' }

export default {
  name: 'ConstantesModal',
  props: {
    visible: Boolean,
    titre: { type: String, default: '' },
    /** { consultation: id } | { hospitalisation: id } | { patient: id } */
    cible: { type: Object, default: () => ({}) }
  },
  emits: ['fermer', 'enregistre'],
  data() {
    return { f: { ...VIDE }, enCours: false, erreur: '' }
  },
  computed: {
    imc() {
      const p = parseFloat(String(this.f.poids).replace(',', '.'))
      const t = parseFloat(this.f.taille)
      return p && t ? (p / ((t / 100) ** 2)).toFixed(1).replace('.', ',') : null
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.f = { ...VIDE }
        this.erreur = ''
      }
    }
  },
  methods: {
    async enregistrer() {
      this.enCours = true
      this.erreur = ''
      try {
        const res = await api.post('constantes', { ...this.cible, ...this.f })
        if (res.data.alertes?.length) {
          notifier('À signaler au médecin : ' + res.data.alertes.join(', '), 'warning')
        } else {
          notifier('Constantes enregistrées.', 'success')
        }
        this.$emit('enregistre', res.data)
        this.$emit('fermer')
      } catch (e) {
        this.erreur = messageErreur(e)
      } finally {
        this.enCours = false
      }
    }
  }
}
</script>

<style scoped>
.cv-fond { position: fixed; inset: 0; background: rgba(0, 0, 0, .45); z-index: 1060; display: flex; align-items: flex-start; justify-content: center; padding: 40px 16px; overflow-y: auto; }
.cv-carte { width: 100%; max-width: 760px; border-radius: 12px; }
</style>
